import { render, staticRenderFns } from "./Mapi.vue?vue&type=template&id=fb528168&"
import script from "./Mapi.vue?vue&type=script&lang=js&"
export * from "./Mapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports